import { useField } from "formik";
import React from "react";
import { z } from "zod";
import FormikLexicalEditor, {
  type Props as FormikLexicalEditorProps,
} from "../WysiwygEditor/lexical/FormikEditor";

type Props = {
  maxLength: number;
  plainFieldName: string;
} & FormikLexicalEditorProps;
export const LexicalControlWithMaxLength: React.FC<Props> = ({
  maxLength,
  plainFieldName,
  settings,
  ...props
}) => {
  const [field] = useField<unknown>(plainFieldName);

  const currentLength = React.useMemo(() => {
    const plainValue = z.string().safeParse(field.value);
    if (!plainValue.success) {
      return 0;
    }

    return plainValue.data.length;
  }, [field.value]);

  return (
    <FormikLexicalEditor
      helperText={`${maxLength - currentLength}`}
      settings={{ ...settings, plainFieldName }}
      maxLength={maxLength}
      {...props}
    />
  );
};
